import React from 'react';
import PropTypes from 'prop-types';
import { Polygon } from 'react-google-maps';

export const SimpleMapPolygons = ({ item }) => {
  const geometry = (item.polygon || []).map(pol => ({
    lng: parseFloat(pol[1]),
    lat: parseFloat(pol[0]),
  }));

  const polygonOptions = {
    fillColor: '#009471',
    strokeColor: '#009471',
    fillOpacity: 0.3,
    strokeOpacity: 0.8,
    strokeWeight: 2,
    zIndex: 1,
    clickable: false,
    draggable: false,
    editable: false,
    geodesic: false,
    visible: true,
  };

  return <Polygon paths={geometry} options={polygonOptions} />;
};

SimpleMapPolygons.propTypes = {
  item: PropTypes.shape({
    polygon: PropTypes.arrayOf(PropTypes.array).isRequired,
  }).isRequired,
};
